import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import "./css/RealTimeWaveForm.css";
import Form from "react-bootstrap/Form";
import WaveformAnalysisAPI from "../../../../../api/WaveformApi";
import Cookies from "js-cookie";
import ReactLoading from "react-loading";
import TrendingAnalysisAPI from "../../../../../api/TrendingAnalysisApi";
import Dropdown from "react-dropdown";

const analysisOptions = [
    {
        label: "None",
        value: "None",
    },
    {
        label: "ZC Calculation",
        value: "zc_calculation",
    },
    {
        label: "dVdT Calculation",
        value: "snar",
    },
    {
        label: "Power Factor ZC",
        value: "pf_zc",
    },
];

const channelMapRegex =
    /(?=.*0)(?=.*1)(?=.*2)(?=.*3)(?=.*4)(?=.*5)^([-n]?[0-5])(?:[ _]?([-n]?[0-5]))(?:[ _]?([-n]?[0-5]))(?:[ _]?([-n]?[0-5]))(?:[ _]?([-n]?[0-5]))(?:[ _]?([-n]?[0-5]))$/;

export default function RTWaveform({ tabData, setTabData, setPlotsOrder, rtMeteringData, setRTMeteringData }) {
    const token = Cookies.get("Session");
    const portalToken = Cookies.get("portalSession");

    // extarcting from redux slice
    const { selectedCustomer, selectedFacility, selectedEquipment, equipmentTimezone, showSELMenu } = useSelector(
        (state) => state.equipmentsPortfolio
    );
    const selectedVoltageType = useSelector((state) => state.voltageType.selectedVoltageType);

    // RealTime Waveform Plot Hooks
    const [realTimeWaveformAlert, setRealTimeWaveformAlert] = useState({
        color: "blue",
        text: "",
        show: false,
    });

    const [displayLLCurrent, setDisplayLLCurrent] = useState(false);

    const [movingAvgLength, setMovingAvgLength] = useState(1);
    const [isMovingAvgLengthInvalid, setIsMovingAvgLengthInvalid] = useState(false);

    const [analysisType, setAnalysisType] = useState(analysisOptions[0]);

    const [displayChannelMap, setDisplayChannelMap] = useState(false);
    const [currentChannelMap, setCurrentChannelMap] = useState("");
    const [customChannelMap, setCustomChannelMap] = useState("");
    const [isChannelMapValid, setIsChannelMapValid] = useState(true);
    {
        /************************************ RealTime Waveform Tab fuctions **************************************************************/
    }

    const getChannelMapping = (displayed = displayChannelMap) => {
        setCurrentChannelMap("");
        if (selectedEquipment && displayed) {
            TrendingAnalysisAPI.getChannelMapping(token, selectedEquipment.value)
                .then((response) => {
                    if (response.status === 200) {
                        if (response.data.content == null) {
                            const text = response.data.info;
                            setRealTimeWaveformAlert({
                                text: text,
                                color: "primary",
                                show: true,
                            });
                        } else {
                            setCurrentChannelMap(response.data.content.channel_map);
                        }
                    } else if (response.status === 204) {
                        setRealTimeWaveformAlert({
                            text: "No Channel Mapping Found",
                            color: "primary",
                            show: true,
                        });
                    }
                })
                .catch((error) => {
                    setRealTimeWaveformAlert({
                        text: "No Channel Mapping Found",
                        color: "primary",
                        show: true,
                    });
                });
        }
    };

    const onDisplayChannelMap = (checked) => {
        setDisplayChannelMap(checked);
        getChannelMapping(checked);
    };

    useEffect(() => {
        getChannelMapping();
    }, [selectedEquipment]);

    const onChannelMapChange = (event) => {
        const val = event.target.value;
        const illegalChars = /[^0-5 \-n_]/;

        if (illegalChars.test(val)) {
            event.preventDefault();
            return;
        }

        const valid = channelMapRegex.test(val);

        setCustomChannelMap(val);
        setIsChannelMapValid(valid);
    };

    useEffect(() => {
        if (tabData.showPlot && tabData.plotMetaData.selectedEquipment == selectedEquipment) {
            onRealTimeWaveformPlotButtonClick();
        }
    }, [selectedVoltageType]);

    const onMovingAvgLengthChange = (newLength) => {
        //Add time delay for set / replot
        const length = parseFloat(newLength);
        setMovingAvgLength(length);
        if (length >= 1 && length <= 512) {
            setIsMovingAvgLengthInvalid(false);
        } else {
            setIsMovingAvgLengthInvalid(true);
        }
    };

    const onRealTimeWaveformPlotButtonClick = async () => {
        if (!selectedCustomer) {
            setRealTimeWaveformAlert({
                color: "primary",
                text: "Select a Customer",
                show: true,
            });
        } else if (!selectedFacility) {
            setRealTimeWaveformAlert({
                color: "primary",
                text: "Select a Facility",
                show: true,
            });
        } else if (!selectedEquipment) {
            setRealTimeWaveformAlert({
                color: "primary",
                text: "Select an Equipment",
                show: true,
            });
        } else if (isMovingAvgLengthInvalid) {
            setRealTimeWaveformAlert({
                color: "primary",
                text: "Please select value between 1 and 512",
                show: true,
            });
        } else if (displayChannelMap && !isChannelMapValid) {
            setRealTimeWaveformAlert({
                color: "primary",
                text: "Invalid Channel Mapping. Enter exactly 6 values 0-5 (may be negative)",
                show: true,
            });
        } else {
            clearInterval(window.waveformMeteringId);
            setRealTimeWaveformAlert({ ...realTimeWaveformAlert, show: false });
            setPlotsOrder({
                rtWaveform: 1,
                waveform: 2,
            });
            setTabData((prevState) => {
                return {
                    ...prevState,
                    plotData: {
                        Np_I_peak: { x: "", y: "" },
                        Time: [],
                        I1: [],
                        I2: [],
                        I3: [],
                        V1: [],
                        V2: [],
                        V3: [],
                        analysis: {},
                    },
                    tableData: { rows: "", columns: [] },
                    isPlotLoading: true,
                    plotMetaData: {
                        selectedEquipment: selectedEquipment,
                        selectedVoltageType: selectedVoltageType,
                        movingAvgLength: movingAvgLength,
                        equipmentTimezone: equipmentTimezone.value,
                        displayLLCurrent: displayLLCurrent,
                        analysisType: analysisType.value,
                    },
                    showPlot: true,
                };
            });
            setRTMeteringData((prevState) => {
                return {
                    ...prevState,
                    tableData: { rows: "", columns: [] },
                    isPlotLoading: true,
                    plotMetaData: {
                        selectedEquipment: selectedEquipment,
                        selectedVoltageType: selectedVoltageType,
                        movingAvgLength: movingAvgLength,
                        equipmentTimezone: equipmentTimezone.value,
                        displayLLCurrent: displayLLCurrent,
                    },
                    showPlot: true,
                    plotData: {
                        connectedStatus: "",
                        current: 0,
                        current1: 0,
                        current2: 0,
                        current3: 0,
                        displayEquipmentType: "",
                        displayTimestamp: "",
                        equipmentType: "",
                        facilityName: "",
                        facilityPortfolio: null,
                        fieldCurrent: null,
                        fieldVoltage: null,
                        hp: 0,
                        iNoise: 0,
                        isCalibrated: null,
                        lineFrequency: 0,
                        locationId: "",
                        meterString: null,
                        meteringStatus: "",
                        name: "",
                        power: 0,
                        powerDailyAverage: null,
                        powerDailyAverageKw: null,
                        powerDailyPeak: null,
                        powerDailyPeakKw: null,
                        powerFactor: 0,
                        powerFactor1: 0,
                        powerFactor2: 0,
                        powerFactor3: 0,
                        powerKw: 0,
                        powerTodayAverage: null,
                        powerTodayAverageKw: null,
                        powerTodayPeak: null,
                        powerTodayPeakKw: null,
                        powerdailyAverage: null,
                        powerdailyPeak: null,
                        runningTime: 0,
                        runningTimeDays: 0,
                        secondarySerialNumber: null,
                        serialNumber: "",
                        siteName: "",
                        status: "",
                        timestamp: 0,
                        timezone: "",
                        type: "",
                        vNoise: 0,
                        voltage: 0,
                        voltage1: 0,
                        voltage2: 0,
                        voltage3: 0,
                        voltageAB: 0,
                        voltageBC: 0,
                        voltageCA: 0,
                    },
                };
            });

            const parsedChannelMap = customChannelMap.match(channelMapRegex)?.slice(1).join("_").replaceAll("-", "n");

            WaveformAnalysisAPI.getRTPlotData(
                token,
                selectedEquipment.value,
                movingAvgLength,
                selectedVoltageType.value,
                displayLLCurrent,
                analysisType.value,
                currentChannelMap,
                parsedChannelMap
            )
                .then((response) => {
                    if (response.status === 204) {
                        setTabData((prevState) => {
                            return {
                                ...prevState,
                                isPlotLoading: false,
                            };
                        });

                        setRealTimeWaveformAlert({
                            color: "primary",
                            text: "No Data Found",
                            show: true,
                        });
                    } else if (response.status === 200) {
                        setTabData((prevState) => {
                            return {
                                ...prevState,
                                plotData: response.data.content.plot_data,
                                tableData: response.data.content.table_data,
                                showPlot: true,
                                isPlotLoading: false,
                            };
                        });
                        setPlotsOrder({
                            rtWaveform: 1,
                            waveform: 2,
                        });
                    }
                })
                .catch((error) => {
                    setTabData((prevState) => {
                        return {
                            ...prevState,
                            isPlotLoading: false,
                        };
                    });
                    console.log(error);
                });

            window.waveformMeteringId = setInterval(() => {
                TrendingAnalysisAPI.getPortalRealTimeMetering(
                    portalToken,
                    selectedEquipment.location_node_id.split(".")[0],
                    selectedVoltageType.value
                )
                    .then((response) => {
                        if (response.status === 200) {
                            if (response.data.data.status === "OFFLINE") {
                                clearInterval(window.waveformMeteringId);
                                const msg =
                                    selectedEquipment.location_node_id.split(".")[1] == "0"
                                        ? "Equipment is Not Cloud Connected"
                                        : "Primary Node Location is Not Cloud Connected";
                                setRealTimeWaveformAlert({
                                    color: "primary",
                                    show: true,
                                    text: msg,
                                });
                            } else if (
                                selectedEquipment.location_node_id.split(".")[1] == "1" &&
                                response.data.data.secondaryConnectedStatus === "OFFLINE"
                            ) {
                                clearInterval(window.waveformMeteringId);
                                setRealTimeWaveformAlert({
                                    color: "primary",
                                    show: true,
                                    text: "Equipment is Not Cloud Connected",
                                });
                            }
                            if (response.data.data.displayTimestamp !== null) {
                                setRTMeteringData((prevState) => {
                                    return {
                                        ...prevState,
                                        plotData: response.data.data,
                                    };
                                });
                            }
                        }
                    })
                    .catch((error) => {
                        clearInterval(window.waveformMeteringId);
                        console.log(error);
                    });
            }, 2000);
        }
    };

    return (
        <div>
            <Row>
                <Col>
                    <h2 className="margin-top-10">Real-time Waveforms</h2>
                </Col>
            </Row>
            <br></br>
            <Row>
                <Col className={showSELMenu ? "col-5 d-none" : "col-5"}>
                    <label>Select Analysis Type:</label>
                    <br></br>
                    <Dropdown options={analysisOptions} value={analysisType} onChange={(val) => setAnalysisType(val)} />
                </Col>
            </Row>
            <br />
            <Row>
                <Col>
                    <label>Enter length for moving average:</label>
                    <br></br>
                    <Col className="col-8 margin_left_-15 waveform-sec-ctn">
                        <Form.Control
                            type="number"
                            min={1}
                            max={512}
                            value={movingAvgLength}
                            onInput={(newDuration) => onMovingAvgLengthChange(newDuration.target.value)}
                            isInvalid={isMovingAvgLengthInvalid}
                            required
                        />
                    </Col>
                </Col>
            </Row>
            <br />
            <Row>
                <Col>
                    <Form.Check
                        onChange={(event) => {
                            setDisplayLLCurrent(event.target.checked);
                        }}
                        type="checkbox"
                        label="Display L-L Current"
                        checked={displayLLCurrent}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Check
                        onClick={(event) => {
                            onDisplayChannelMap(event.target.checked);
                        }}
                        type="checkbox"
                        label="Set Custom Channel Mapping"
                        checked={displayChannelMap}
                    />
                </Col>
            </Row>
            {displayChannelMap && (
                <>
                    <br />
                    <Row>
                        <Col>
                            Current Channel Mapping: <br /> {currentChannelMap}
                        </Col>
                        <Col>
                            <label>Enter Custom Channel Mapping:</label>
                            <br></br>
                            <Form.Control
                                value={customChannelMap}
                                onInput={(event) => onChannelMapChange(event)}
                                isInvalid={!isChannelMapValid}
                                required
                            />
                        </Col>
                    </Row>
                </>
            )}
            <br></br>
            <Row>
                <Col className="col-2">
                    {tabData.isPlotLoading ? (
                        <ReactLoading type="bars" color="#007bff" height={50} width={50} />
                    ) : (
                        <Button variant="primary" onClick={onRealTimeWaveformPlotButtonClick} className="plot_button">
                            Plot
                        </Button>
                    )}
                </Col>
                <Col className="col-5 waveformAlert">
                    <Alert
                        variant={realTimeWaveformAlert.color}
                        show={realTimeWaveformAlert.show}
                        onClose={() =>
                            setRealTimeWaveformAlert({
                                ...realTimeWaveformAlert,
                                show: false,
                            })
                        }
                        dismissible
                    >
                        {realTimeWaveformAlert.text}
                    </Alert>
                </Col>
            </Row>
        </div>
    );
}
